import React from 'react';
import { ClipboardCheck } from 'lucide-react';
import { clinicalSummaries } from '../data/clinicalSummaries';

const ROWS = [
  ['who', 'Who it helps'],
  ['how', 'How we treat it'],
  ['next', 'Next step'],
];

// Highlighted "Clinical Summary" callout — who / how / next, in the clinic's own voice.
export default function ClinicalSummary({ id, compact = false, className = '' }) {
  const s = clinicalSummaries[id];
  if (!s) return null;
  if (compact) {
    return (
      <p className={`clinical-summary-line ${className}`} data-testid={`clinical-summary-${id}`}>
        <strong>Clinical summary:</strong> {s.short}
      </p>
    );
  }
  return (
    <aside className={`clinical-summary ${className}`} data-testid={`clinical-summary-${id}`} aria-label="Clinical summary">
      <p className="clinical-summary-label"><ClipboardCheck size={16} aria-hidden="true" /> Clinical Summary</p>
      <dl className="clinical-summary-rows">
        {ROWS.map(([key, label]) => (
          <div key={key} className="clinical-summary-row">
            <dt>{label}</dt>
            <dd>{s[key]}</dd>
          </div>
        ))}
      </dl>
    </aside>
  );
}
